/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Payment_TitleInputs */

const da_terms_payment_title = /** @type {(inputs: Terms_Payment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaling og fornyelse`)
};

/** @type {(inputs: Terms_Payment_TitleInputs) => LocalizedString} */
const en_terms_payment_title = da_terms_payment_title;

/**

* @param {Terms_Payment_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_payment_title = /** @type {((inputs?: Terms_Payment_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Payment_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_payment_title(inputs)
	return /** @type {LocalizedString} */ ("Betaling og fornyelse")
});